<template>
   <v-layout>
  <v-snackbar
    v-model="snackbar.visible"
    :color="snackbar.color"
    :location="snackbar.position === 'top' ? 'top' : 'bottom'"
    multi-line
    :timeout="snackbar.timeout"
  >
    <div class="d-flex align-center">
            <v-icon 
            class="pr-3"
            icon="mdi-alert" 
            dark large
            ></v-icon>
      <div class="text-subtitle-1 font-weight-bold">
        {{ snackbar.title }}
      </div>
    </div>
    <div class="mt-2">{{ snackbar.text }}</div>

    <template #actions>
          <v-btn
            color="indigo"
            variant="text"
            @click="snackbar.visible = false"
          >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>

     <TopBarMenu :basins="basins" 
                  :scenarios="scenarios"
                  :chartData="chartData"
                  :infoData="display_indicator_info"
                  :display_indicator_info = "display_indicator_info"
                  @sendDataRequest="handleBasinDataRequest"
      />   
      <MapComponent
          :api-key="apiKey"
          :style-url="styleUrl"
          :center="center_map"
          :zoom= "mapZoom"
          :features="features"
          :features_color_legend = "features_color_legend"
          @emitSubasinName="handleSubasinDataRequest"
      />

    </v-layout>
    <v-layout>
        <ProjectFooter />
    </v-layout>

</template>

<script setup>
import MapComponent from './components/MapComponent.vue';
import TopBarMenu from './components/TopBarMenu.vue';
import ProjectFooter from './components/ProjectFooter.vue'

import {ref, onMounted} from 'vue'

import * as api_json from '../data/api_config.json'
const api_json_obj = JSON.parse(JSON.stringify(api_json));

const end_point = api_json_obj.api_url;
const drawer_data_end_point = end_point + api_json_obj.drawer_data_end_point; 
const geo_data_end_point = end_point + api_json_obj.geo_data_end_point; 
const indicator_display_info_end_point = end_point + api_json_obj.indicator_display_info_end_point;
const sos_view_end_point = end_point + api_json_obj.sos_view_end_point;



const apiKey = 'I5iFasWwZw2hLPKVaaVa';
const styleUrl = 'https://api.maptiler.com/maps/streets-v2/style.json?';
const center_map = ref([16.3713, 48.2081]); // starting position [lng, lat]
const mapZoom = ref(5);

const basins = ref([]);
//const scenarios = ref([]);

const chartData = ref('');


const features = ref({'features':[]});
const features_color_legend = ref(null);
const error = ref(null);

const display_indicator_id = ref(-1);
const display_indicator_info = ref({

    "indicator_id": null, 
   "indicator_name": null, 
   "indicator_threshold": null, 
   "basin_id": null, 
   "indicator_description": null, 
   "indicator_label": null, 
   "function_name": null, 
   "function_id": null
  });

const chart_sub_basin_id = ref('')
const chart_scenario_id = ref('')

const snackbar = ref({
            color: "warning",
            icon: "warning",
            mode: "multi-line",
            position: "top",
            timeout: 7500,
            title: "Warning",
            text: "The data dsiplayed in this page are for testing purposes only.",
            visible: true
            }
          )


  onMounted (()=>{
     //basins.value = data_json.basin_data;
    loadDrawerData();

  });


  const handleSubasinDataRequest = (clicked_subasin) =>{
    //change the sub basin data in the radial chart but keep geo json and indicator info

    var select_request = {
          'basin_id': clicked_subasin.basin_id,
          'subasin_id': clicked_subasin.subasin_id,
          'indicator_id': clicked_subasin.indicator_id,
          'scenario_id': clicked_subasin.scenario_id
      }

      loadSosChartData(select_request);
  }

  //handle basin-indicator request
  const handleBasinDataRequest = (request_data) => {
    // console.log('App received data');
    //console.log(request_data);

    //TODO: prevent loading json if basin-indicator did not change
    loadGeoJson(request_data);
    loadIndicatorInfo(request_data);
    loadSosChartData(request_data);

  }

  async function loadGeoJson(request_data) {

    error.value = null;

    try {

      var basin_id = request_data.basin_id;
      var indicator_id = request_data.indicator_id;
      var scenario_id = request_data.scenario_id;

      var geo_data_end_point_url = geo_data_end_point + '/' + basin_id.toString() + '/' + indicator_id.toString() + '/' + scenario_id.toString()


      const response = await fetch(geo_data_end_point_url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const json_response_data = await response.json();
      //const json_response_data = JSON.parse(rawJson);
      features.value = json_response_data.basin_geo_data;
      features_color_legend.value = json_response_data.legend; //get the legend based on indicator threshold
      center_map.value = json_response_data.display_info.lat_lon;
      mapZoom.value = json_response_data.display_info.zoom;

    } catch (err) {
      console.error('Error fetching or converting data:', err);
      error.value = err;
    } 
    finally{
      if (error.value != null){
        console.log(error.value);
      }
    }

  }

  async function loadIndicatorInfo(request_data) {
      //load indicator info to be displayed in the right drawer

    error.value = null;

    try {

      var basin_id = request_data.basin_id;
      var indicator_id = request_data.indicator_id;

      if(indicator_id != display_indicator_id.value){


        var info_end_point_url = indicator_display_info_end_point + '/' + basin_id.toString() + '/' + indicator_id.toString();


        const response = await fetch(info_end_point_url);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const json_response_data = await response.json();

        display_indicator_info.value.indicator_id = json_response_data.indicator_id 
        display_indicator_info.value.indicator_name = json_response_data.indicator_name
        display_indicator_info.value.indicator_threshold = json_response_data.indicator_threshold
        display_indicator_info.value.basin_id = json_response_data.basin_id
        display_indicator_info.value.indicator_description = json_response_data.indicator_description
        display_indicator_info.value.indicator_label = json_response_data.indicator_label
        display_indicator_info.value.function_name = json_response_data.function_name
        display_indicator_info.value.function_id = json_response_data.function_id
      }
        
    } catch (err) {
      console.error('Error fetching or converting data:', err);
      error.value = err;
    } 
    finally{
      if (error.value != null){
        console.log(error.value);
      }
    }

  }

  async function loadSosChartData(request_data) {
      //load indicator info to be displayed in the right drawer

    error.value = null;

    try {

      var scenario_id = request_data.scenario_id;
      var sub_basin_id = request_data.subasin_id;


      if(sub_basin_id != chart_sub_basin_id.value && scenario_id != chart_scenario_id.value){


        var sos_view_end_point_url = sos_view_end_point + '/' + scenario_id.toString() + '/' + sub_basin_id.toString();


        const response = await fetch(sos_view_end_point_url);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const json_response_data = await response.json();

        chartData.value = json_response_data.chart_data;
        request_data.scenario_id = scenario_id;
        request_data.sub_basin_id = sub_basin_id;

        //chartData.value = data_json_obj.chart_data3;

      }
        
    } catch (err) {
      console.error('Error fetching or converting data:', err);
      error.value = err;
    } 
    finally{
      if (error.value != null){
        console.log(error.value);
      }
    }

  }

  async function loadDrawerData() {
    //Loads the basins data (scenarios, indicators, functions etc.) for the left drawarer

    error.value = null;

    try {
      const response = await fetch(drawer_data_end_point);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const json_response_data = await response.json();
      //const json_response_data = JSON.parse(rawJson);
      basins.value = json_response_data.basins_data;

    } catch (err) {
      console.error('Error fetching or converting data:', err);
      error.value = err;
    } 
    finally{
      if (error.value != null){
        console.log(error.value);
      }
    }
  }

</script>

<style>


body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.app {
  text-align: center;



.info-overlay {
  position: fixed;
  bottom: 20%;
  right: 5px;
  left:55%;
  width: 40%;
  border: 3px solid #73AD21;
}


}
</style>